import { defineComponent as _defineComponent } from 'vue'
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from "primevue/useconfirm";

import {useI18n} from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialogYesNo',
  emits: ['accepted', 'rejected'],
  setup(__props, { expose: __expose, emit: __emit }) {

const confirm = useConfirm();
const i18n = useI18n();

const emit = __emit;

__expose({confirmRequired});

function confirmRequired(data:any){
  confirm.require({
    message: i18n.t('MODAL.CONFIRMATION_MESSAGE_REMOVE_ELEMENT'),
    header: i18n.t('MODAL.CONFIRMATION_HEADER'),
    icon: 'pi pi-exclamation-triangle',
    acceptClass: 'p-button-danger',
    acceptLabel: i18n.t('POPUPS.GENERAL.yes'),
    rejectLabel: i18n.t('POPUPS.GENERAL.no'),
    acceptIcon: 'pi pi-check',
    rejectIcon: 'pi pi-times',
    accept: () => {
      //callback to execute when user confirms the action
      emit('accepted',  data);
    },
    reject: () => {
      //callback to execute when user rejects the action
      emit('rejected',  data);
    }
  });
}


const __returned__ = { confirm, i18n, emit, confirmRequired, get ConfirmDialog() { return ConfirmDialog } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})